export default {
  name: 'lx-success-modal',
  props: {
    text: String,
  },
}
